
import { Component, Vue } from 'vue-property-decorator';
import { InvoiceApi, InvoiceOpenAmountsResponse } from '@/api';
import getConfiguration from '@/store/getConfiguration';
import TableSearchField from '@/components/table/TableSearchField.vue';
import TableFilter from '@/components/table/TableFilter.vue';
import BaseCurrencyAmount from '@/components/BaseCurrencyAmount.vue';
import InvoiceStatusEnum from '@/types/invoices/InvoiceStatusEnum';

interface CurrencyValue {
  currency?: string;
  amount?: number;
}

@Component({
  components: { BaseCurrencyAmount, TableFilter, TableSearchField },
})
export default class InvoicesActionBar extends Vue {
  filterOptions: InvoiceStatusEnum[] = Object.values(InvoiceStatusEnum);

  totals: InvoiceOpenAmountsResponse = {};

  fetchedTotals = false;

  get total(): CurrencyValue | null {
    const mapping: { [key: string]: string } = {
      'eq(AccStatusText,before due)': 'before_due_totals',
      'eq(AccStatusText,due date)': 'due_date_totals',
      'eq(AccStatusText,overdue)': 'overdue_totals',
      'eq(AccStatusText,cleared)': '',
      'eq(AccStatusText,reversed)': '',
    };
    const { filter } = this.$store.state.invoice;
    const key = filter in mapping ? mapping[filter] : 'total_amounts';
    if (key === '') {
      return {};
    }
    const values: any = this.totals;
    const totalAmounts: any = values[key];
    if (totalAmounts) {
      const currencies = Object.keys(totalAmounts);
      if (currencies.length) {
        const currency: string | undefined = currencies.pop();
        const amount: number = currency ? totalAmounts[currency] : 0;
        return { currency, amount };
      }
    }
    return {};
  }

  get totalLabel(): string {
    return this.$store.state.invoice.filter ? 'total-filtered' : 'total';
  }

  async created() {
    if (!this.fetchedTotals) {
      await this.fetchTotals();
      this.fetchedTotals = true;
    }
  }

  async fetchTotals() {
    const configuration = await getConfiguration();
    const api = new InvoiceApi(configuration, '');
    const response = await api.openAmountInvoicesGet();
    this.totals = response?.data || {};
  }
}
